import React from 'react';
import clsx from 'clsx';

import { InfoInvIcon } from '../../icons/InfoInvIcon';

export const Paper = ({ children, className }: { children: React.ReactNode; className?: string }) => (
    <div className={clsx('nui-paper px-10 py-10 bg-black-4 br-radius-xs', className)}>{children}</div>
);

export const InfoPaper = ({ children, className }: { children: React.ReactNode; className?: string }) => (
    <Paper className={clsx('flex justify-start fs-14 c-black-50-2', className)}>
        <div className="mr-10">
            <InfoInvIcon />
        </div>
        <div>{children}</div>
    </Paper>
);
